import { AxiosResponse } from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import camelize from '@/tools/camelize';
// import { pluralizeAge } from '@/tools/pluralize';
import { ACTION_FETCH } from './const';
import {
  OrganizationExtended,
  Organization,
  Params,
  Programs,
  Providers,
  RootState,
  // Teachers,
  State,
  Statuses,
} from './types';

const { ERROR, READY, WAITING } = Statuses;

const intialize = (): Organization => ({
  contacts: {
    address: '',
    email: '',
    phone: '',
  },
  coords: {
    latitude: null,
    longitude: null,
  },
  description: '',
  id: '',
  logo: '',
  municipalityId: '',
  name: '',
  photos: [],
  teachers: [],
});

const FETCH_ORGANIZATION = 'fetchOrganization';
const FETCH_PROGRAMS = 'fetchPrograms';
const SET_ORGANIZATION = 'setOrganization';
const SET_PROGRAMS = 'setPrograms';
const SET_STATUS = 'setStatus';

const storeModule = ({ $api, $config }: Providers) => {
  let request: null | Promise<any> = null;

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageOrganizationStore extends VuexModule<State, RootState> {
    // State
    organization: Organization = intialize();
    programs: Programs = [];
    status: Statuses = READY;

    // Getters
    get full(): OrganizationExtended {
      const { municipalities } = this.context.rootState;
      const { organization } = this;
      const { municipalityId } = organization;
      const result = municipalities.find(
        ({ id }) => String(id) === String(municipalityId),
      );
      return { ...organization, municipality: result };
    }

    // Mutations
    @Mutation
    [SET_ORGANIZATION](organization: Organization) {
      const blank = intialize();
      this.organization = {
        ...blank,
        ...organization,
      };
    }

    @Mutation
    [SET_PROGRAMS](programs: Programs = []) {
      this.programs = programs;
    }

    @Mutation
    [SET_STATUS](status: Statuses) {
      this.status = status;
    }

    // Actions
    @Action
    async [ACTION_FETCH](params: Params) {
      const { commit, dispatch } = this.context;
      if (request) return;
      try {
        const organization: Promise<void> = dispatch(
          FETCH_ORGANIZATION,
          params,
        );
        const programs: Promise<void> = dispatch(FETCH_PROGRAMS, params);
        request = Promise.all([organization, programs]);
        await request;
        commit(SET_STATUS, READY);
      } catch (e) {
        // Обрабатываем ошибку
        commit(SET_STATUS, ERROR);
      } finally {
        request = null;
      }
    }

    @Action({ commit: SET_ORGANIZATION })
    async [FETCH_ORGANIZATION](params: Params) {
      const { data } = await $api.get<AxiosResponse<Organization>>(
        'organization/get',
        { params },
      );
      /*const count = 8; // Количество заглушек для фото
      data.data.teachers = data.data.teachers.map(teacher => {
        return {
          ...teacher,
          age: pluralizeAge(teacher.age),
          programsLink: `/directivities?educator=${teacher.id}`,
          image: Math.floor(Math.random() * count) + 1,
        };
      });*/
      return camelize(data.data);
    }

    @Action({ commit: SET_PROGRAMS })
    async [FETCH_PROGRAMS]({ id }: Params) {
      const params = {
        organizer: id,
        limit: $config.organizations.card.programsCount,
      };
      const { data } = await $api.get<AxiosResponse<Programs>>('events/get', {
        params,
      });
      return data.data;
    }
  }

  return PageOrganizationStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/store.ts